import { helpBotClient } from '../../axiosClients'

export const sendHelpBotMessage = async ({ question, history, sessionId }) => {
    const response = await helpBotClient.post('', {
        question,
        provider: 'anthropic',
        history,
        session_id: sessionId,
        source_url: window.location.href,
    })

    return response.data
}
